import { render, staticRenderFns } from "./works.vue?vue&type=template&id=1cdea652&"
import script from "./works.vue?vue&type=script&lang=js&"
export * from "./works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports